/* eslint-disable no-prototype-builtins */
import moment, { Moment } from "moment";
import "moment/locale/ro";
import {
  ResolutionBreakPoints,
  ENDPOINTS_SKIP_WORK_POINT_ID,
  ENDPOINTS_SKIP_INSTRUCTOR_ID,
} from "./Constants";
import { ETaskStatus, EWordpressStockStatus } from "./Enums";
import { Vocabulary } from "./Vocabulary";
import htmlToDraft from "html-to-draftjs";
import { ContentState, EditorState } from "draft-js";
import axios, { AxiosResponse } from "axios";
import { endpoints } from "./UrlEnum";
import { toast } from "react-toastify";
import { format } from "date-fns";
import React from "react";
import { Link } from "@mui/material";
import Config from "./Config";
import { getData } from "../Services/getData";

moment.locale("ro");

/**
 *
 * @param model
 * @param propertiesArray
 * @returns
 */
// export const generateFormData = (model: any) => {
//   const formData = new FormData();

//   for (const property in model) {
//     if (typeof model[property] === "boolean")
//       formData.append(property, model[property]);
//     else formData.append(property, model[property] ? model[property] : null);
//   }

//   return formData;
// };

/**
 *
 */
export function logout() {
  localStorage.removeItem("userId");
  localStorage.removeItem("fullName");
  localStorage.removeItem("access_token");
  localStorage.removeItem("storage");
  localStorage.removeItem("userName");
  localStorage.removeItem("userRoles");
  localStorage.removeItem("managements");
  localStorage.removeItem("orderOfferPassword");
  localStorage.removeItem("userWorkPointId");
  localStorage.removeItem("userInstructorId");
}

/**
 *
 * @param model Main model (object)
 * @param completedData The object that is completed and can have undefined props
 * @returns New Filtered Object (Return is present to be easier to understand what the function will return)
 */
export const mergeObjects = (model: any, completedData: any) => {
  for (const idx in completedData) {
    if (completedData[idx] !== undefined) model[idx] = completedData[idx];
  }
  return model;
};

/**
 *
 * @param discount
 * @param quantity
 * @param unitPrice
 * @returns
 */
export const calcValue = (discount: any, quantity: any, unitPrice: any) => {
  const totalPrice = parseFloat(quantity) * parseFloat(unitPrice);
  const totalPriceWithDiscount =
    (parseFloat(quantity) * parseFloat(unitPrice) * parseFloat(discount)) / 100;
  const total = totalPrice - totalPriceWithDiscount;

  return isNaN(total) ? 0 : total;
};

/**
 *
 * @param wordpressPrice
 * @param tva
 * @returns
 */
export const calcPriceWithoutTVA = (wordpressPrice: any, tva: any) => {
  const priceWithoutTVA =
    (parseFloat(wordpressPrice) * 10000) /
    ((1 + parseFloat(tva) / 100) * 10000);
  return isNaN(priceWithoutTVA) ? 0 : priceWithoutTVA;
};

/**
 *
 * @param wordpressPrice
 * @param tva
 * @returns
 */
export const calcTVAValue = (wordpressPrice: any, tva: any) => {
  const priceWithoutTVA =
    wordpressPrice - parseFloat(wordpressPrice) / (1 + parseFloat(tva) / 100);
  return isNaN(priceWithoutTVA) ? 0 : priceWithoutTVA;
};

/**
 *
 * @param priceWithoutTVA
 * @param tva
 * @returns
 */
export const calcTVAValueFromPriceWithoutTVA = (
  priceWithoutTVA: any,
  tva: any,
) => {
  const newPriceWithoutTVA = (tva / 100) * priceWithoutTVA;
  return isNaN(newPriceWithoutTVA) ? 0 : newPriceWithoutTVA;
};
/**
 *
 * @param value
 * @param tva
 * @returns
 */
export const calcValueWithTVA = (value: any, tva: any) => {
  const valueWithTVA =
    parseFloat(value) + parseFloat(value) * (parseFloat(tva) / 100);
  return isNaN(valueWithTVA) ? 0 : valueWithTVA;
};

/**
 *
 * @param price
 * @param tva
 * @returns
 */
export const calculatePriceWithTVA = (price: any, tva: any) => {
  const valueWithTVA =
    parseFloat(price) + parseFloat(price) * (parseFloat(tva) / 100);
  if (isNaN(valueWithTVA)) return 0;
  //  check number of decimals in valueWithTVA
  const decimals = valueWithTVA.toString().split(".")[1]?.length;
  //if the number of decimals is greater than 2, round the value
  return decimals > 2 ? getRoundedValue(valueWithTVA, 2) : valueWithTVA;
  // return valueWithTVA;
};

/**
 *
 * @param value
 * @param decimals
 * @returns
 */
const getRoundedValue = (value: any, decimals: number) => {
  if (isNaN(value)) return 0;
  return (Math.round((value + Number.EPSILON) * 100) / 100).toFixed(decimals);
};

/**
 *
 * @param unitPrice
 * @param quantity
 * @returns
 */
export const calculateTotal = (unitPrice: any, quantity: any) => {
  //parse values to float
  const unitPriceFloat = parseFloat(unitPrice);
  const quantityFloat = parseFloat(quantity);
  //calculate total
  const total = unitPriceFloat * quantityFloat;
  //return total
  return isNaN(total) ? 0 : total;
};

/**
 *
 * @param discount
 * @param quantity
 * @param unitPrice
 * @returns
 */
export const calcDiscount = (discount: any, quantity: any, unitPrice: any) => {
  const subTotal =
    (parseFloat(quantity) * parseFloat(unitPrice) * parseFloat(discount)) / 100;
  return isNaN(subTotal) ? 0 : subTotal;
};

/**
 *
 * @param file
 * @returns
 */
export const resizeImage = (file: any) => {
  const promise = new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.onload = function (readerEvent) {
        const image = new Image();
        image.src = readerEvent.target?.result as string;
        image.onload = function (imageEvent) {
          const imageFile = resize(image, file.name);
          resolve(imageFile);
        };
        image.onerror = function (err) {
          reject(err);
        };
      };
      reader.readAsDataURL(file);
    } catch (e) {
      reject(e);
    }
  });
  return promise;
};

/**
 *
 * @param image
 * @param fileName
 * @returns
 */
const resize = (image: any, fileName: any) => {
  const canvas = document.createElement("canvas");
  let { width } = image,
    { height } = image;
  const maxWidth = width > 200 ? 200 : width;
  if (width > height) {
    if (width > maxWidth) {
      height *= maxWidth / width;
      width = maxWidth;
    }
  } else {
    if (height > maxWidth) {
      width *= maxWidth / height;
      height = maxWidth;
    }
  }
  canvas.width = width;
  canvas.height = height;
  canvas?.getContext("2d")?.drawImage(image, 0, 0, width, height);
  const dataUrl = canvas.toDataURL("image/png");
  const resizedImage = dataURLToBlob(dataUrl);
  return blobToFile(resizedImage, fileName);
};

/**
 *
 * @param {*} dataURL
 * @param {*} fileName
 * @returns
 */
export function dataURLToBlob(dataURL: any) {
  const BASE64_MARKER = ";base64,";

  let parts = dataURL.split(BASE64_MARKER);
  let contentType = parts[0].split(":")[1];
  let raw = window.atob(parts[1]);
  const rawLength = raw.length;

  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    parts = dataURL.split(",");
    contentType = parts[0].split(":")[1];
    raw = parts[1];
    return new Blob([raw], { type: contentType });
  }
  const uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  const blob = new Blob([uInt8Array], { type: contentType });
  return blob;
}

/**
 *
 * @param {*} ab
 * @param {*} fileName
 * @returns
 */
function blobToFile(ab: any, fileName: any) {
  const f = new File([ab], fileName, {
    type: "image/jpeg",
    lastModified: new Date().getTime(),
  });
  return f;
}

/**
 *
 * @param file
 * @returns
 */
export const toBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

/**
 *
 * @param routePath
 * @param currentPath
 * @returns
 */
export const mainPathMatches = (routePath: string, currentPath: any) => {
  if (routePath?.endsWith("?")) {
    // If the route path ends with '?', check only the part before the '?'
    return currentPath.startsWith(routePath.slice(0, -1));
  }
  //id the route contains / check only the first part of the path
  if (
    routePath?.includes("/") &&
    routePath?.length > 3 &&
    routePath?.split("/").length > 2
  ) {
    return currentPath?.startsWith(`/${routePath.split("/")[1]}`);
  }
  // Otherwise, check the whole path
  return currentPath === routePath;
};

/**
 *
 * @param routePath
 * @param currentPath
 * @returns
 */
export const checkSecondaryPathsMatch = (
  routePath: string,
  currentPath: any,
) => {
  if (routePath?.endsWith("?")) {
    // If the route path ends with '?', check only the part before the '?'
    return currentPath.startsWith(routePath.slice(0, -1));
  }
  // Otherwise, check the whole path
  return currentPath === routePath;
};

/**
 *
 * @param date
 * @param format
 * @returns
 */
export const formatStringDate = (
  date: string | Date | Moment | null | undefined,
  format: any,
) => {
  if (!date) return null;
  return moment(date).format(format);
};

/**
 *
 * @param url
 */
export const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

/**
 *
 * @param timestamp
 * @param format
 * @returns
 */
export const formatTimestamp = (timestamp: any, format: any) => {
  const timestampToDate = new Date(timestamp * 1000);
  const response = moment(timestampToDate).format(format);
  return response && response !== "Invalid date" ? response : "";
};

/**
 * checks if device is mobile
 * @returns
 */
export const isMobile = () => {
  return document.body.offsetWidth <= ResolutionBreakPoints.sm;
};

/**
 * check if device is tablet
 * @returns
 */
export const isTablet = () => {
  return document.body.offsetWidth <= ResolutionBreakPoints.lg;
};

/**
 * Check if mobile menu/drawer should be shown
 * This matches the CSS breakpoint where desktop menu is hidden (< 1590px)
 * @returns true if the mobile drawer should be rendered
 */
export const shouldShowMobileMenu = () => {
  return document.body.offsetWidth < 1590;
};

/**
 *
 * @param backgroundColor
 * @returns
 */
export const setFontColorBasedOnBackground = (backgroundColor: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    backgroundColor,
  );

  // If regex doesn't match, return black as default
  if (!result) {
    return "#000";
  }

  const sum =
    parseInt(result[1], 16) / 2 +
    parseInt(result[2], 16) / 2 +
    parseInt(result[3], 16) / 2;

  // Dark background (sum <= 127) needs white text, light background needs black text
  if (sum > 127) {
    return "#000";
  }
  return "#fff";
};
/**
 *
 * @param str
 * @returns
 */
export const replaceAllUnescapedChars = (str: string) => {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")
    .replace(/ /g, "&nbsp;");
};

/**
 *
 * @param str
 * @returns
 */
export const restoreAllEscapedChars = (str: string) => {
  return str
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&nbsp;/g, " ");
};

/**
 *
 * @param html
 * @returns
 */
export const decodeHtml = (html: string) => {
  const e = document.createElement("div");
  e.innerHTML = html;
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
};

/**
 *
 * @param html
 * @returns
 */
export const extractStringFromHtml = (html: string): string => {
  // Create a temporary container element
  const container = document.createElement("div");
  // Set the HTML content of the container
  container.innerHTML = html;

  // Function to recursively traverse through the DOM nodes
  const getText = (node: any) => {
    let text = "";
    // Iterate over child nodes
    node.childNodes.forEach((child: any) => {
      // If it's a text node, append its content
      if (child.nodeType === Node.TEXT_NODE) {
        text += child.textContent;
      } else if (
        child.nodeType === Node.ELEMENT_NODE &&
        child.tagName.toLowerCase() !== "style"
      ) {
        // If it's an element node and not a <style> tag, recursively get its text content
        text += getText(child);
      }
    });
    return text;
  };

  // Call the getText function starting from the container element
  return getText(container);
};

/**
 *
 * @param str
 * @returns
 */
export const isStringOnlyHTML = (str: string) => {
  const fragment = document.createRange().createContextualFragment(str);

  // remove all non text nodes from fragment
  fragment.querySelectorAll("*").forEach((el: any) => {
    if (el.childNodes.length === 0) {
      el.parentNode.removeChild(el);
    }
  });

  // if there is textContent, then not a pure HTML
  return !(fragment.textContent || "").trim();
};

/**
 *
 * @param html
 * @returns
 */
export const getHtml = (html: string) => {
  const contentBlock = htmlToDraft(html);
  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks,
  );
  return EditorState.createWithContent(contentState);
};

/**
 *
 * @param html
 * @returns
 */
export const sanitizeHtml = (html: string): string => {
  // Create a DOMParser to parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // Remove script elements
  const scriptElements = doc.querySelectorAll("script");
  scriptElements.forEach((script) => {
    script.parentNode?.removeChild(script);
  });

  // Remove link elements (including their attributes)
  // const linkElements = doc.querySelectorAll("link");
  // linkElements.forEach((link) => {
  //   link.parentNode?.removeChild(link);
  // });

  // Serialize the cleaned DOM back to a string
  const cleanedHtml = new XMLSerializer().serializeToString(doc);

  return cleanedHtml;
};

/**
 *
 * @param users
 * @returns
 */
export const mapUserListToChatSuggestions = (users: any) => {
  return users?.map((participant: any) => {
    return {
      text: `${participant.user.lastName || ""} ${
        participant.user.firstName || ""
      }`,
      value: `${participant.user.lastName || ""} ${
        participant.user.firstName || ""
      }`,
      url: "",
    };
  });
};

export const checkIfStringContainsOnlyOneChar = (str: string, char: string) => {
  if (!str) return null;
  //remove spaces from string
  str = str.replace(/\s/g, "");
  //check if string contains only one char
  return str.length === 1 && str === char ? null : str;
};

/**
 *
 * @param stockStatus
 * @returns
 */
export const renderStockMessage = (stockStatus: string | null) => {
  switch (stockStatus) {
    case EWordpressStockStatus.OUT_OF_STOCK:
      return Vocabulary.outOfStock;
    case EWordpressStockStatus.IN_STOCK:
      return Vocabulary.inStock;
    case EWordpressStockStatus.ON_BACKORDER:
      return Vocabulary.onBackOrder;
    default:
      return Vocabulary.inStock;
  }
};

/**
 * Make an HTTP request using Axios.
 * @param url The URL to send the request to.
 * @param method The HTTP method to use (e.g., 'GET', 'POST', etc.).
 * @param token The authorization token to include in the request headers.
 * @param body The request body (optional).
 * @returns A promise that resolves to the AxiosResponse.
 */
export const makeRequest = async (
  url: string,
  method: string,
  token: string,
  body?: any,
): Promise<AxiosResponse<any>> => {
  try {
    const response = await axios({
      url,
      method,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: body,
    });
    return response;
  } catch (error) {
    // Handle error (e.g., log it or throw a custom error)
    console.error("Request failed:", error);
    throw error; // Rethrow the error to propagate it up the call stack
  }
};

/**
 *
 * @param name
 * @returns
 */
export const stringAvatar = (name: string) => {
  if (!name) return null;
  const nameSplit = name?.split(" ");
  return {
    children: `${!nameSplit.length ? "" : nameSplit?.[0]?.[0] || ""}${
      nameSplit?.[1]?.[0] || ""
    }`,
  };
};

/**
 *
 * @param obj
 */
export const removeNullProperties = (obj: { [key: string]: any }) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (
        obj[key] === null ||
        (Array.isArray(obj[key]) && obj[key].length === 0)
      ) {
        delete obj[key];
      } else if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
        // Recursively call the function for nested objects
        removeNullProperties(obj[key]);
        // After recursive call, delete the property if the nested object is empty
        if (checkIfObjectIsEmpty(obj[key])) {
          delete obj[key];
        }
      }
    }
  }
};

/**
 *
 * @param obj
 * @returns
 */
export const checkIfObjectIsEmpty = (obj: any) => {
  return Object.keys(obj).length === 0;
};

/**
 *
 * @param chat
 * @returns
 */
export const checkIfChatHasUnreadMessages = (chat: any) => {
  //check if chat has messages and lastRead is smaller than the curent timestamp
  const lastRead = chat?.lastRead;
  //get last message timestamp
  const lastMessageTimestamp =
    chat?.messages?.[chat?.messages?.length - 1]?.timestamp;
  return chat?.messages?.length > 0 && lastRead < lastMessageTimestamp;
};

/**
 *
 * @param property
 * @returns
 */
export const checkIfPropertyIsString = (property: any) => {
  return typeof property === "string" || property instanceof String;
};

/**
 * test if file is image
 * @param file
 * @returns
 */
export const isImage = (file: any) => {
  const ext = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
  return ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif";
};

/**
 *
 * @param text
 * @returns
 */
export const getNumberOfLinesFromText = (text: string | null | undefined) => {
  if (text) {
    const splittedText = text.split(/\r\n|\r|\n/);
    let numLines = splittedText.length;
    splittedText.forEach((line: string) => {
      if (line.length > 90) {
        numLines += line.length / 90;
      }
    });
    return numLines;
  }
  return 2;
};

/**
 *
 * @param file
 */
export const downloadFile = (file: any) => {
  fetch(`${endpoints.media.public}?path=${file?.path}`)
    .then((response) => response.blob())
    .then((response) => {
      if (response.size === 0) {
        toast.warn(Vocabulary.missingFile);
        return;
      }
      const href = URL.createObjectURL(response);
      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", file.name); //or any other extension
      document.body.appendChild(link);
      link.click();
      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
};

/**
 * Downloads a blob as a file.
 * @param response The blob to download
 * @param fileName The file name to use for the download
 * @param type The MIME type of the blob
 */
export async function download(response: Blob, fileName: string, type: string) {
  // Create a new blob from the response
  const blob = new Blob([response], { type });

  // Create a URL for the blob
  const url = URL.createObjectURL(blob);

  // Create a link element
  const link = document.createElement("a");
  link.download = fileName; // Set the file name for the download
  link.href = url; // Set the href to the blob URL

  // Append the link to the body (not always necessary, but good for cross-browser support)
  document.body.appendChild(link);

  // Trigger the download by simulating a click
  link.click();

  // Clean up: remove the link from the document and revoke the object URL
  document.body.removeChild(link);
  URL.revokeObjectURL(url); // Free up memory
}

/**
 *
 * @param file
 * @param type
 * @returns
 */
export const checkFileType = (file: any, type: string) => {
  const ext = file.name.substring(file.name.lastIndexOf(".") + 1).toLowerCase();
  return ext === type;
};

/**
 *
 * @param path
 * @returns
 */
export function getFileExtensionByFileType(path: string) {
  const splitName = path.split(".").reverse();
  const extension = splitName.length ? splitName[0] : null;
  return extension;
}

/**
 *
 * @param model
 */
export const onFormError = (model: any) => {
  console.log("Full form model:", model);

  // Log errors specifically (if you want to distinguish errors from valid fields)
  if (model?.errors) {
    console.log("Form Errors:", model.errors);
  }
};

/**
 *
 * @param task
 * @returns
 */
export const checkIfTaskIsLate = (task: any) => {
  //check if task end date is before today and status is not finished
  if (!task.status || task.status.name === ETaskStatus.CUSTOM) return false;
  const endDate = new Date(task.end);
  const finishDate = task.finishDate ? new Date(task.finishDate) : null;
  return (
    (moment(task.end).isBefore(moment().subtract(1, "days").endOf("day")) &&
      task.status?.name !== ETaskStatus.FINISHED) ||
    (finishDate && finishDate > endDate)
  );
};

/**
 *
 * @param obj
 * @param excludedFields
 * @returns
 */
export const filterFields = (obj: any, excludedFields: Array<string>) => {
  return Object.keys(obj)?.filter((key) => !excludedFields.includes(key));
};

/**
 *
 * @param bgColor
 * @returns
 */
export const getTextColorBasedOnBg = (color: string) => {
  const hex = color.replace("#", "");

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 128 ? "black" : "white";
};

/**
 * Convert hex color to approximate color name
 * @param hex - The hex color code (with or without #)
 * @returns The approximate color name in Romanian
 */
export const hexToColorName = (hex: string): string => {
  if (!hex) return "";

  const cleanHex = hex.replace("#", "").toLowerCase();

  // Common color mappings (hex -> Romanian name)
  const colorMap: Record<string, string> = {
    "000000": "Negru",
    ffffff: "Alb",
    ff0000: "Roșu",
    "00ff00": "Verde",
    "0000ff": "Albastru",
    ffff00: "Galben",
    ff00ff: "Magenta",
    "00ffff": "Cyan",
    "808080": "Gri",
    c0c0c0: "Argintiu",
    "800000": "Maro închis",
    "808000": "Măsliniu",
    "008000": "Verde închis",
    "800080": "Mov",
    "008080": "Turcoaz",
    "000080": "Bleumarin",
    ffa500: "Portocaliu",
    ffc0cb: "Roz",
    a52a2a: "Maro",
    d2691e: "Ciocolatiu",
    ff6347: "Roșu tomat",
    "4169e1": "Albastru regal",
    "32cd32": "Verde lime",
    ffd700: "Auriu",
    daa520: "Auriu închis",
    b8860b: "Auriu maro",
    cd853f: "Bej",
    f5deb3: "Grâu",
    ffe4c4: "Biscuit",
    ffebcd: "Migdale",
    f0e68c: "Kaki",
    e6e6fa: "Lavandă",
    dda0dd: "Prun",
    ee82ee: "Violet",
    da70d6: "Orhidee",
    ff1493: "Roz aprins",
    ff69b4: "Roz intens",
    db7093: "Roz pal",
    b0c4de: "Albastru oțel",
    add8e6: "Albastru deschis",
    "87ceeb": "Albastru cer",
    "87cefa": "Albastru cer deschis",
    "00bfff": "Albastru intens",
    "1e90ff": "Albastru Dodger",
    "6495ed": "Albastru floare de porumb",
    "7b68ee": "Albastru mediu",
    "6a5acd": "Albastru ardezie",
    "483d8b": "Albastru ardezie închis",
    "191970": "Albastru miezul nopții",
    "2e8b57": "Verde mare",
    "3cb371": "Verde mare mediu",
    "20b2aa": "Verde mare deschis",
    "98fb98": "Verde pal",
    "00fa9a": "Verde primăvară",
    "7fff00": "Verde chartreuse",
    "7cfc00": "Verde iarbă",
    adff2f: "Verde galben",
    "556b2f": "Verde măsliniu închis",
    "6b8e23": "Verde măsliniu",
    "9acd32": "Verde galben",
    "8fbc8f": "Verde mare închis",
    "228b22": "Verde pădure",
    "006400": "Verde închis",
    bdb76b: "Kaki închis",
    f0fff0: "Verde mieros",
    f5fffa: "Verde mentă",
    e0ffff: "Cyan deschis",
    afeeee: "Turcoaz pal",
    "40e0d0": "Turcoaz",
    "48d1cc": "Turcoaz mediu",
    "00ced1": "Turcoaz închis",
    "5f9ea0": "Albastru cadet",
    "4682b4": "Albastru oțel",
    b0e0e6: "Albastru pudră",
    f0f8ff: "Albastru Alice",
    f8f8ff: "Alb fantomă",
    f5f5f5: "Alb fum",
    dcdcdc: "Gri deschis",
    d3d3d3: "Gri pal",
    a9a9a9: "Gri închis",
    "696969": "Gri mat",
    "778899": "Gri ardezie deschis",
    "708090": "Gri ardezie",
    "2f4f4f": "Gri ardezie închis",
    fffaf0: "Alb floral",
    fdf5e6: "Alb vechi",
    faf0e6: "Lenjerie",
    faebd7: "Alb antic",
    ffe4e1: "Roz ceață",
    fff0f5: "Lavandă roz",
    fffafa: "Zăpadă",
    f0ffff: "Azur",
    fffff0: "Fildeș",
    fffacd: "Lămâie",
    fff8dc: "Mătase porumb",
    ffffe0: "Galben deschis",
    fafad2: "Auriu deschis",
    eee8aa: "Auriu pal",
    f5f5dc: "Bej deschis",
    ffe4b5: "Mocasin",
    ffdead: "Navajo alb",
    ffdab9: "Piersică",
    ffe5b4: "Piersică deschis",
    ffefd5: "Papaya",
    d2b48c: "Bronz",
    deb887: "Lemn",
    f4a460: "Nisip",
    e9967a: "Somon închis",
    fa8072: "Somon",
    ffa07a: "Somon deschis",
    ff7f50: "Coral",
    ff4500: "Portocaliu roșu",
    dc143c: "Stacojiu",
    b22222: "Cărămiziu",
    "8b0000": "Roșu închis",
    cd5c5c: "Roșu indian",
    bc8f8f: "Roz maro",
    f08080: "Coral deschis",
    ffb6c1: "Roz deschis",
    c71585: "Violet roșu mediu",
    "9370db": "Mov mediu",
    ba55d3: "Orhidee mediu",
    "9932cc": "Orhidee închis",
    "8b008b": "Magenta închis",
    "4b0082": "Indigo",
  };

  // Check for exact match
  if (colorMap[cleanHex]) {
    return colorMap[cleanHex];
  }

  // Find closest color by RGB distance
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);

  let closestColor = "";
  let minDistance = Infinity;

  for (const [hexCode, name] of Object.entries(colorMap)) {
    const r2 = parseInt(hexCode.substring(0, 2), 16);
    const g2 = parseInt(hexCode.substring(2, 4), 16);
    const b2 = parseInt(hexCode.substring(4, 6), 16);

    const distance = Math.sqrt(
      Math.pow(r - r2, 2) + Math.pow(g - g2, 2) + Math.pow(b - b2, 2),
    );

    if (distance < minDistance) {
      minDistance = distance;
      closestColor = name;
    }
  }

  return closestColor;
};

export function getPreviewPaths(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value
      .map((val: any) => {
        if (typeof val === "string") {
          return val.startsWith("/") ? val : `/${val}`;
        } else if (val instanceof File) {
          return URL.createObjectURL(val);
        } else if (val?.document) return `/${val?.document}`;
        return "";
      })
      ?.filter((path) => path !== "");
  } else if (value instanceof File) {
    return [URL.createObjectURL(value)];
  } else if (typeof value === "string") {
    return [value.startsWith("/") ? value : `/${value}`];
  } else if (
    typeof value === "object" &&
    value !== null &&
    (value as any)?.document
  ) {
    return [`/${(value as any).document}`];
  }
  return [];
}

export const OrderStatusType = {
  Certification: "Atestat",
  License: "Permis",
};

export const OrderStatus = {
  written1: "Teoretic 1",
  practical: "Examen Practic",
  theoretical: "Examen Teoretic",
  certificate: "Atestat",
};

export const ExamState = {
  pratical: "practical",
  theoretical: "theoretical",
};
/**
 * Format a date according to the specified format
 * @param date - The date to be formatted, can be a Date object, a string or a number
 * @param format - The format of the date, default is 'dd.MM.yyyy HH:mm'
 * @returns The formatted date as a string
 */
export function formatDate(date: any, dateFormat = "dd.MM.yyyy") {
  if (date) return format(new Date(date), dateFormat);
}

/**
 * Retrieves an element from an array based on a matching field value.
 *
 * @param array - The array to search within.
 * @param field - An object containing the value to match against the array elements' _id.
 * @returns The element from the array that has an _id matching the field's value, or undefined if no match is found.
 */

export function getValueForAutocomplete(
  array: any,
  field: any,
  filterProperty = "_id",
) {
  if (!Array.isArray(array) || !field) return null;

  const fieldId =
    typeof field === "string"
      ? field
      : field[filterProperty] || field?._id || field.id || field;

  return (
    array.find((element) => {
      const id =
        element[filterProperty] || element._id || element.id || element;
      if (Array.isArray(id)) {
        return (
          JSON.stringify(id) ==
          (Array.isArray(fieldId) ? JSON.stringify(fieldId) : fieldId)
        );
      } else {
        return id == fieldId;
      }
    }) || null
  );
}

/**
 * Represents a generic placeholder for an empty field.
 */
export const genericEmptyField = "---";

/**
 * Checks if a value is a string.
 * @param value
 * @returns true if the value is a string
 */
export const isString = (value: any) => typeof value === "string";

/**
 * Checks if a value is defined.
 * A value is considered defined if it is not undefined, null, or an empty string.
 *
 * @param value - The value to be checked.
 * @returns true if the value is defined, false otherwise.
 */

export const isDefined = (value: any) => {
  if (value === undefined || value === null) return false;
  if (value == "null" || value == "undefined") return false;
  if (isString(value) && value.trim() === "") return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.keys(value).length === 0
  )
    return false;
  return true;
};

export function formatNumber(number: number) {
  return number?.toLocaleString("ro-Ro");
}

/**
 * Format a number from a string.
 * @param {string} number - The string to format
 * @returns {string} The formatted number as a string formatted with decimal separator
 */
export function formatNumberFromString(number: string) {
  if (number) {
    const value = formatNumber(parseFloat(number.replace(/,/g, "")));
    return value?.replace(".", " ") || "";
  }
}

/**
 * Returns the full name of an object.
 * The full name is the concatenation of the first name and the last name.
 *
 * @param {object} object - The object from which to get the full name.
 * @returns {string} The full name of the object.
 */
export const getFullName = (object: any) => {
  if (!object) return "";
  return `${object.lastName} ${object.firstName}`;
};

/**
 * Converts a time duration from minutes into a formatted string of hours and minutes.
 *
 * @param {number} minutes - The time duration in minutes.
 * @returns {string} A formatted string representing the duration in hours and minutes.
 *                   The format is "X h Y min", where X is the number of hours and Y is the number of minutes.
 *                   If hours are zero, only the minutes are shown, and vice versa.
 */

export function formatMinutesToHours(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  const hoursPart = h > 0 ? `${h} h` : "";
  const minutesPart = m > 0 ? `${m} min` : "";

  return [hoursPart, minutesPart]?.filter(Boolean).join(" ");
}

export function getCurrentWeek(date = new Date()) {
  const current = new Date(date);
  const currentDay = current.getDay(); // 0 (Sun) - 6 (Sat)

  // Normalize so Monday is the first day
  const dayOffset = (currentDay + 6) % 7; // 0=Mon, 6=Sun

  const monday = new Date(current);
  monday.setDate(current.getDate() - dayOffset);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { start: monday, end: sunday };
}

/**
 * Renders a styled table link for MUI DataTables using Material-UI Link component
 * @param url - The base URL to navigate to
 * @param rowData - The display text for the link
 * @param tableMeta - The table metadata containing row data
 * @param idIndex - Optional index of the ID in the row data (defaults to 0)
 * @returns JSX element containing the styled link
 */
export const renderTableLink = (
  url: string,
  rowData: any,
  tableMeta: any,
  idIndex = 0,
) => {
  const id = tableMeta.rowData[idIndex];
  if (!id) return rowData;

  /**
   * Returns a styled link for MUI DataTables using Material-UI Link component
   */
  return React.createElement(
    Link,
    {
      href: `${url}/${id}`,
      target: "_blank",
      rel: "noopener noreferrer",
      underline: "hover",
      color: "black",
      sx: {
        cursor: "pointer",
        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
    rowData,
  );
};

/**
 * Adds workPointId query parameter to URL for Functionar role users
 * @param url - The URL to modify
 * @param baseURL - The base URL (optional)
 * @param skipWorkPointId - Skip adding workPointId parameter (optional)
 * @returns Modified URL with workPointId parameter if applicable
 */
export const addWorkPointIdToUrl = (
  url: string,
  baseURL?: string,
  skipWorkPointId?: boolean,
): string => {
  if (skipWorkPointId) {
    return url;
  }

  // Skip workPointId for specific endpoints
  const shouldSkip =
    Object.values(ENDPOINTS_SKIP_WORK_POINT_ID).some((endpoint) =>
      url.includes(endpoint),
    ) || url.includes("globalSearch");
  if (shouldSkip) {
    return url;
  }

  const userRoles = localStorage.getItem("userRoles");
  const userWorkPointId = localStorage.getItem("userWorkPointId");

  if (!userRoles || !userWorkPointId) {
    return url;
  }

  try {
    const roles = JSON.parse(userRoles);
    const isAdmin = roles.some(
      (role: any) => role.name === Config.roles.ADMIN,
    );
    const isFunctionar = roles.some(
      (role: any) => role.name === Config.roles.OFFICE_ASSISTANT,
    );

    if (isFunctionar && !isAdmin) {
      const urlObj = new URL(url, baseURL || window.location.origin);
      if (!urlObj.searchParams.has("workPointId")) {
        urlObj.searchParams.set("workPointId", userWorkPointId);
        return urlObj.pathname + urlObj.search;
      }
    }
  } catch (error) {
    console.warn("Error parsing user roles:", error);
  }

  return url;
};

/**
 * Adds instructorId query parameter to URL for Instructor role users
 * @param url - The URL to modify
 * @param baseURL - The base URL (optional)
 * @param skipInstructorId - Skip adding instructorId parameter (optional)
 * @returns Modified URL with instructorId parameter if applicable
 */
export const addInstructorIdToUrl = (
  url: string,
  baseURL?: string,
  skipInstructorId?: boolean,
): string => {
  if (skipInstructorId) {
    return url;
  }

  // Skip instructorId for specific endpoints
  const shouldSkip = Object.values(ENDPOINTS_SKIP_INSTRUCTOR_ID).some(
    (endpoint) => url.includes(endpoint),
  );
  if (shouldSkip) {
    return url;
  }

  const userRoles = localStorage.getItem("userRoles");
  const userInstructorId = localStorage.getItem("userInstructorId");

  if (!userRoles || !userInstructorId) {
    return url;
  }

  try {
    const roles = JSON.parse(userRoles);
    const isAdmin = roles.some(
      (role: any) => role.name === Config.roles.ADMIN,
    );
    const isInstructor = roles.some(
      (role: any) => role.name === Config.roles.INSTRUCTOR,
    );

    if (isInstructor && !isAdmin) {
      const urlObj = new URL(url, baseURL || window.location.origin);
      if (!urlObj.searchParams.has("instructorId")) {
        urlObj.searchParams.set("instructorId", userInstructorId);
        return urlObj.pathname + urlObj.search;
      }
    }
  } catch (error) {
    console.warn("Error parsing user roles:", error);
  }

  return url;
};

/**
 * Validates if a date string is a valid date
 * @param dateString - The date string to validate
 * @returns true if the date is valid, false otherwise
 */
export const removeDiacritics = (s: string | null | undefined): string => {
  if (!s) return "";
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "");
};

export const isValidDate = (dateString: string): boolean => {
  if (!dateString) return false;
  const date = moment(
    dateString,
    ["DD.MM.YYYY", "DD/MM/YYYY", "YYYY-MM-DD"],
    true,
  );
  return date.isValid();
};

export default function appendFormData(
  formData: any,
  data: any,
  parentKey = "",
) {
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      const formKey = parentKey ? `${parentKey}[${key}]` : key;

      if (value instanceof File) {
        formData.append(formKey, value);
      } else if (
        typeof value === "object" &&
        value !== null &&
        !(value instanceof File)
      ) {
        formData.append(formKey, JSON.stringify(value));
      } else {
        formData.append(formKey, value);
      }
    }
  }
}

/**
 * Fetches the list of all products from the server.
 * The data is retrieved from the products endpoint and returned as an array.
 * If the response contains no data, the function exits early.
 * @returns {Promise<Array<any>>} - A promise that resolves to an array of products
 */
export function fetchProducts() {
  return async () => {
    const response: any = await getData(
      `${endpoints.product.main}/paginated?page=0&perPage=100000`,
    );

    return response?.data?.results || [];
  };
}

/**
 * Fetches instructors from the API.
 * @returns {Promise<Array<any>>} - A promise that resolves to an array of instructors
 */
export function fetchInstructors() {
  return async () => {
    const response: any = await getData(
      `${endpoints.instructor.user}/paginated?page=0&perPage=100000`,
    );

    return response?.data?.results || [];
  };
}

/**
 * Fetches all document types from the API.
 * @returns {Promise<Array<any>>} - A promise that resolves to an array of document types
 */
export function fetchAllDocumentTypes() {
  return async () => {
    const response: any = await getData(endpoints.documentTypes);

    return response?.data || [];
  };
}
